module.exports = __webpack_public_path__ + "img/bedland_slide_3.f552faec.jpg";